module.exports = __webpack_public_path__ + "static/img/startExp.b16ff16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/startExp.png
// module id = CcDB
// module chunks = 1